import { useRouteError } from 'react-router';

import { Box, Button, Flex } from '@valwin/facto/components';

export function GlobalErrorFallback() {
  const error = useRouteError() as Error;

  const isChunkError =
    error?.message?.includes('preload') ||
    error?.message?.includes('Loading chunk');

  const onButtonClick = () => {
    location.reload();
  };

  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap="4"
      minHeight="vh"
    >
      <Box textAlign="center">
        <Box fontSize="lg">Oups ! Une erreur est survenue</Box>
        <Box fontSize="sm">
          {isChunkError
            ? 'Une nouvelle version est disponible.'
            : "Un problème est survenu lors de l'affichage."}
        </Box>
      </Box>

      <Button onClick={onButtonClick}>Recharger la page</Button>
    </Flex>
  );
}
